import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 404 && error.error?.message?.includes('User not approved')) {
        if (error.error.user) {
          localStorage.setItem('Pending_User_Data', JSON.stringify(error.error.user));
        }

        // Redirect to your approval-pending page
        router.navigate(['/approval'], { replaceUrl: true });
      }

      return throwError(() => error);
    })
  );
};